import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import ScrollIndicator from "./ScrollIndictator";
import Socials from "./socials";
import Footer from "./Footer";

import Project, { ProjectData } from "./project";

export default function Sidebar({
  projects,
  onProjectClick,
  selectedProject,
}: {
  projects: ProjectData[];
  onProjectClick: (project: ProjectData) => void;
  selectedProject: ProjectData | null;
}) {
  const { t } = useTranslation("common");
  const scrollAreaRef = React.useRef<HTMLDivElement>(null);
  const [scrollPos, setScrollPos] = useState(0);

  useEffect(() => {
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLElement;
      setScrollPos(target.scrollTop);
    };

    const container = scrollAreaRef.current;
    container?.addEventListener("scroll", handleScroll);

    return () => {
      container?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={
        "w-full xl:w-96 h-full p-12 pt-6 overflow-scroll overflow-x-hidden bg-gray-100 shadow-lg relative"
      }
      ref={scrollAreaRef}
    >
      {/* SOCIALS */}
      <Socials />

      <h1 className={"text-center handwriting text-2xl font-bold"}>
        {t("sidebar.title")}
      </h1>
      <p className={"text-center text-base text-gray-700"}>
        {t("sidebar.description")}
      </p>

      {/* PROJECT */}
      <div
        className={
          "mt-10 grid grid-col gap-20 justify-center items-center relative max-w-xs m-auto"
        }
      >
        {projects.map((project, index) => {
          return (
            <a
              key={index}
              href={"/" + project.title}
              onClick={(e) => {
                e.preventDefault();
                onProjectClick(project);
              }}
            >
              <Project project={project} />
            </a>
          );
        })}
      </div>

      {/* SCROLL */}
      <ScrollIndicator scrollPosition={scrollPos} />

      {/* FOOTER */}
      <Footer />
    </div>
  );
}
